module.exports = __webpack_public_path__ + "img/111.3cd0c7a0.jpg";